import React from 'react';
import { ScheduleIcon } from '../../Icons';
import { Nullable, SearchItemViewModel, SearchMeta } from '../types';
import { convertToBillingUrl } from '../../../nav/utils/getBillingBaseUrl';

const chipState = {
  Pending: 'default',
  PartiallyProcessed: 'primary',
  FullyProcessed: 'success',
};

function renderItem(invoiceSchedule, t): Nullable<SearchItemViewModel> {
  return {
    title: invoiceSchedule['Number'],
    descriptionFields: [
      {
        type: 'Text',
        value: invoiceSchedule['Account.Name'],
        title: invoiceSchedule['Account.Name'],
      },
      {
        type: 'Text',
        value: invoiceSchedule['Account.AccountNumber'],
        title: invoiceSchedule['Account.AccountNumber'],
      },
    ],
    chipField: {
      state: chipState[invoiceSchedule['Status']],
      label: t(`InvoiceSchedule.Status.${invoiceSchedule['Status']}`),
    },
    href: convertToBillingUrl(
      `/platform/invoice-schedules/${invoiceSchedule.Number}`,
    ),
  };
}

export const InvoiceSchedule: SearchMeta = {
  objectType: 'InvoiceSchedule',
  objectLabelI18n: 'InvoiceSchedule.TabLabel',
  tabIcon: <ScheduleIcon />,
  needsPermission: true,
  listPageUrl: '',
  hasAdvancedSearch: true,
  renderItem,
};
